import aiGenerationStatuses from '../constants/aiGenerationStatuses';
import ANALYSIS_POLLING_TIMEOUT_MS from '../constants/analysisPollingTimeout';
import { ICaseAnalysis } from './schemas/caseAnalysis';

const isAnalysisExpired = (analysis: ICaseAnalysis): boolean => (
  analysis.status === aiGenerationStatuses.CREATED
  && Date.now() - new Date(analysis.createdAt).getTime() > ANALYSIS_POLLING_TIMEOUT_MS
);

export default isAnalysisExpired;
